<template>
  <BlokkliProvider v-slot="{ entity }" v-bind="blokkliProps" :entity="props">
    <PageHeader
      :tagline="entity?.leadTitle || leadTitle"
      :title="entity?.title || title"
      :lead="entity?.intro || intro"
      :teaser-image="image"
      :inverted="hasBackground"
    />

    <div class="bg-gray-50">
      <BlokkliField
        :list="paragraphs"
        name="field_paragraphs"
        :allowed-fragments="[
          'dynamic_contact',
          'glossary_list',
          'voting',
          'person_list',
          'news_list',
          'mailxpert',
          'cassia_widget',
        ]"
      />
    </div>
  </BlokkliProvider>
</template>

<script lang="ts" setup>
import type { NodePageFragment } from '#graphql-operations'

const props = defineProps<{
  __typename?: string
  title?: string
  intro?: string
  leadTitle?: string
  teaserImage?: NodePageFragment['teaserImage']
  heroImage?: NodePageFragment['heroImage']
  pageColor?: string
  hasBackground?: boolean
  paragraphs?: NodePageFragment['paragraphs']
  body?: string
  blokkliProps: NodePageFragment['blokkliProps']
}>()

const { hasBackground, htmlClasses } = usePageState(props)

const image = computed(() => {
  return props.heroImage
})

useHead({
  htmlAttrs: {
    class: htmlClasses,
  },
})
</script>
